// An Higher Order Component that looks at the current theme and selects the appropriate component to render based on the theme.
import { createElement as rc } from 'react';
import { useTheme } from 'styled-components';

export const _private = {
    useTheme
};
/**
 * @typedef { {
 *   theme?: string,
 *   component: React.ComponentType
 * }} ConditionalComponent
 */

/**
 * @param {ConditionalComponent[]} conditionalComponents
 */
export default function ThemeComponentSwitcher(conditionalComponents) {
    return function ThemeComponentSwitcherInner(props) {
        const theme = _private.useTheme();
        const themeName = theme?.selectedTheme ?? undefined;
        // get the first component that matches the current theme, or the default component (without a theme)
        const matchedComponent =
            conditionalComponents.find(cc => cc.theme === themeName) ||
            conditionalComponents.find(cc => cc.theme === undefined);
        return rc(matchedComponent.component, props);
    };
}
